@let isEmpty = this.isEmpty();

<div
		[pTooltip]="tooltip() | msgKey"
		tooltipPosition="bottom"
>
	<a
			routerLink="/workflow.do?from=menu&to=shoppingcart"
			[class.disabled]="isEmpty"
	>
		@if (isEmpty) {
			<mat-icon svgIcon="shopping_cart"></mat-icon>
		} @else {
			<p-overlay-badge
					[value]="count()"
					badgeSize="small"
			>
				<mat-icon svgIcon="shopping_cart"></mat-icon>
			</p-overlay-badge>
		}
	</a>
</div>
